module.exports = __webpack_public_path__ + "static/media/villanova-logo.19132aa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/logo/villanova-logo.png
// module id = 952
// module chunks = 0